module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "600px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "modal-body scrollContainer"
  }, _vm._l((_vm.records), function(message, index) {
    return _c('div', {
      key: index,
      staticClass: "chat-message"
    }, [(message.isAnswer) ? _c('div', {
      staticClass: "message-sender-left"
    }, [(message.supplierLogo) ? _c('img', {
      attrs: {
        "title": message.supplierName,
        "src": message.supplierLogo
      }
    }) : _c('img', {
      attrs: {
        "title": message.supplierName,
        "src": "https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (message.isAnswer) ? _c('div', {
      staticClass: "message-content-left"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(message.content)
      }
    }), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sendTime"
    }, [_vm._v(_vm._s(_vm._f("formatDateTime")(message.addTime)))])]) : _vm._e(), _vm._v(" "), (!message.isAnswer) ? _c('div', {
      staticClass: "message-sender-right"
    }, [(message.userLogo) ? _c('img', {
      attrs: {
        "title": "我",
        "src": message.userLogo
      }
    }) : _c('img', {
      attrs: {
        "title": "我",
        "src": "https://file-sz.fjjykj.com.cn/Supply/sbc66de876f0ec3f951eaeab89ad80afb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (!message.isAnswer) ? _c('div', {
      staticClass: "message-content-right"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(message.content)
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sendTime"
    }, [_vm._v(_vm._s(_vm._f("formatDateTime")(message.addTime)))])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-footer dialog-footer",
    attrs: {
      "slot": "footer",
      "element-loading-text": _vm.elementLoadingText
    },
    slot: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1,
      "title": "上传图片"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.aLiction,
      "http-request": _vm.uploadALiFile,
      "before-upload": _vm.beforeAvatarUpload,
      "show-file-list": false,
      "multiple": ""
    }
  }, [_c('img', {
    staticClass: "uploadImage",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/sbddac806328e1be05770a03e26663f8a.jpeg"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    ref: "sendMsg",
    staticClass: "sendMsg",
    attrs: {
      "contenteditable": "true"
    },
    on: {
      "input": _vm.updateContent,
      "paste": _vm.handlePaste
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("发送")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d1d2f1d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/Consult.vue
// module id = 769
// module chunks = 2